import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';

import { AppModule } from './app/app.module';
import { DomUtil } from './app/core/utils/dom.util';

function getHostingEnvironment(): 'dev' | 'staging' | 'prod' {
  const hostname: string = window.location.hostname;
  if (hostname.startsWith('local-') || hostname.startsWith('dev-')) {
    return 'dev';
  } else if (hostname.startsWith('staging-')) {
    return 'staging';
  }
  return 'prod';
}

if (DomUtil.shouldRedirectExtensionLogin()) {
  window.location.replace('/login/public/extension');
} else {
  Sentry.init({
    dsn: 'https://d03f4bea7edbd40370a8cd6a35122393@o12195.ingest.us.sentry.io/4509447649755136',
    environment: getHostingEnvironment(),
  });

  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch(err => console.error(err));
}
